export default __webpack_public_path__ + "static/media/6.ebf4e6da.jpg";